import React from "react";
import { Panel } from "@/components/inquiries/OverviewCharts";

const COLS = [["total", "Total"], ["open", "Open"], ["pending", "Pending"], ["overdue", "Overdue"], ["converted", "Converted"], ["closed", "Closed"]];

export const BreakdownTable = ({ title, rows, onRow, testid }) => (
  <Panel title={title} testid={testid}>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="text-[11px] uppercase tracking-wider text-slate-500">
          <tr className="border-b border-slate-100"><th className="text-left py-2 pr-2">Name</th>
            {COLS.map(([, l]) => <th key={l} className="text-right py-2 px-2">{l}</th>)}<th className="text-right py-2 pl-2">Conv. %</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.key || "none"} data-testid={`${testid}-row-${r.key || "none"}`} onClick={() => onRow(r)} className="border-b border-slate-50 last:border-0 hover:bg-blue-50/40 cursor-pointer">
              <td className="py-2 pr-2 text-slate-800">{r.label}</td>
              {COLS.map(([k]) => <td key={k} className={`py-2 px-2 text-right mono ${k === "overdue" && r[k] ? "text-rose-700 font-semibold" : k === "pending" && r[k] ? "text-amber-700 font-semibold" : "text-slate-700"}`}>{r[k]}</td>)}
              <td className="py-2 pl-2 text-right mono text-emerald-800">{r.conversion_rate == null ? "—" : `${r.conversion_rate}%`}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={8} className="text-center text-slate-500 py-6 text-sm">Nothing to show.</td></tr>}
        </tbody>
      </table>
    </div>
  </Panel>
);
